var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01822 0H7.98178C3.57357 0 0 3.57357 0 7.98178V8.01822C0 12.4264 3.57357 16 7.98178 16H8.01822C12.4264 16 16 12.4264 16 8.01822V7.98178C16 3.57357 12.4264 0 8.01822 0Z",
    fill: "#007EBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81571 5.3188C3.60494 5.12316 3.50012 4.881 3.50012 4.59288C3.50012 4.30475 3.6055 4.05194 3.81571 3.85574C4.02648 3.66011 4.29779 3.56201 4.6302 3.56201C4.96261 3.56201 5.22327 3.66011 5.43348 3.85574C5.64425 4.05138 5.74907 4.29746 5.74907 4.59288C5.74907 4.88829 5.64369 5.12316 5.43348 5.3188C5.22271 5.51443 4.95532 5.61253 4.6302 5.61253C4.30508 5.61253 4.02648 5.51443 3.81571 5.3188ZM5.57194 6.44103V12.439H3.67669V6.44103H5.57194Z",
    fill: "#FEFFFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8809 7.03351C12.2941 7.48196 12.5003 8.09745 12.5003 8.88111V12.333H10.7004V9.12439C10.7004 8.7292 10.5978 8.42201 10.3932 8.20339C10.1886 7.98478 9.91281 7.87491 9.56751 7.87491C9.22221 7.87491 8.9464 7.98422 8.7418 8.20339C8.53719 8.42201 8.43461 8.7292 8.43461 9.12439V12.333H6.62402V6.42418H8.43461V7.20784C8.61792 6.94662 8.86513 6.74034 9.17568 6.58843C9.48623 6.43652 9.83546 6.36084 10.2239 6.36084C10.9157 6.36084 11.4683 6.58506 11.8809 7.03351Z",
    fill: "#FEFFFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinCircle);
export default __webpack_public_path__ + "static/media/linkedin-circle.0ce39b9f6b145b81a0121e7388caa26a.svg";
export { ForwardRef as ReactComponent };